// extracted by mini-css-extract-plugin
export default {"container":"components-Header-LoginStatus-styles-module__container--Yt2Fc"};